export function addBusinessDays(date, days) {
  const result = new Date(date.getTime());
  let remaining = days;
  while (remaining > 0) {
    result.setUTCDate(result.getUTCDate() + 1);
    if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) remaining--;
  }
  return result;
}
export function deliveryDates(date, method = 'standard') {
  const readyMin = addBusinessDays(date, 1);
  const readyMax = addBusinessDays(date, 3);
  const transit = method === 'express' ? [2, 10] : [5, 18];
  return { ordered: date, readyMin, readyMax, arrivalMin: addBusinessDays(readyMin, transit[0]), arrivalMax: addBusinessDays(readyMax, transit[1]) };
}
if (typeof customElements !== 'undefined' && !customElements.get('ox-delivery-timeline')) {
  customElements.define('ox-delivery-timeline', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.select = this.querySelector('[data-delivery-method]');
      this.controller = new AbortController();
      try { if (sessionStorage.getItem('ox-delivery-preview') === 'express') this.select.value = 'express'; } catch {}
      this.select?.addEventListener('change', () => {
        try { sessionStorage.setItem('ox-delivery-preview', this.select.value); } catch {}
        this.renderDates();
      }, { signal: this.controller.signal });
      this.renderDates();
      if (this.select) this.select.disabled = false;
      this.timer = setInterval(() => this.renderDates(), 60000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.controller?.abort(); this.initialized = false; }
    renderDates() {
      const current = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      const part = (name) => current.find((p) => p.type === name).value;
      const today = new Date(Date.UTC(Number(part('year')), Number(part('month')) - 1, Number(part('day')), 12));
      const method = this.select?.value || 'standard';
      const dates = deliveryDates(today, method);
      let formatter;
      try { formatter = new Intl.DateTimeFormat(this.dataset.locale || 'en', { month: 'short', day: 'numeric', timeZone: 'UTC' }); }
      catch { formatter = new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric', timeZone: 'UTC' }); }
      const range = (a, b) => formatter.format(a) + ' – ' + formatter.format(b);
      this.querySelector('[data-delivery-ordered]').textContent = formatter.format(dates.ordered);
      this.querySelector('[data-delivery-ready]').textContent = range(dates.readyMin, dates.readyMax);
      this.querySelector('[data-delivery-arrival]').textContent = range(dates.arrivalMin, dates.arrivalMax);
      this.querySelector('[data-delivery-standard]').hidden = method !== 'standard';
      this.querySelector('[data-delivery-express]').hidden = method !== 'express';
    }
  });
}
